import { render, staticRenderFns } from "./falv.vue?vue&type=template&id=aabde470&scoped=true&"
import script from "./falv.vue?vue&type=script&lang=js&"
export * from "./falv.vue?vue&type=script&lang=js&"
import style0 from "./falv.vue?vue&type=style&index=0&lang=css&"
import style1 from "./falv.vue?vue&type=style&index=1&id=aabde470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabde470",
  null
  
)

export default component.exports